import { useEmberService } from '@qonto/react-migration-toolkit/react/hooks';

interface LocaleManagerService {
  locale: string;
  setLocale: (locale: string) => void;
}

export const useLocaleManager = (): LocaleManagerService => {
  return useEmberService('locale-manager') as unknown as LocaleManagerService;
};
